import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: null,
  accessToken: null,
  refreshToken: null,
  role: null,
  isLoggedIn: false,
  permissions: [],
};

const authSlice = createSlice({
  name: "auth",

  initialState,

  reducers: {
    setCredentials: (state, action) => {
      state.user = action.payload.user;
      state.accessToken = action.payload.accessToken;
      state.refreshToken = action.payload.refreshToken;
      state.role = action.payload.role;
      state.permissions = action.payload.permissions || [];
      state.isLoggedIn = true;
    },

    logout: (state) => {
      state.user = null;
      state.accessToken = null;
      state.refreshToken = null;
      state.role = null;
      state.permissions = [];
      state.isLoggedIn = false;
    },

   
    updateUser: (state, action) => {
      if (state.user) {
        state.user = { ...state.user, ...action.payload };
      } else {
        state.user = action.payload;
      }
    },

    updatePermission: (state, action) => {
      state.permissions = action.payload;
    },
  },
});

export const {
  setCredentials,
  logout,
  updateUser,
  updatePermission,
} = authSlice.actions;

export default authSlice.reducer;